export const LocalStorageKeys = {
    userInfo:'USER-INFO',
    userToken:'USER-TOKEN',
     };